import { z } from 'zod'

import { addressSchema } from '~/components/smart-accounts/schemas/addressSchema'
import { amountSchema } from '~/components/smart-accounts/schemas/amountSchema'
import { relayChainIdSchema } from '~/components/smart-accounts/schemas/relayChainIdSchema'

// For cross-chain transfer destinations that support relay networks.
export const relayTokenAmountSchema = z.object({
  token: addressSchema,
  amount: amountSchema,
  chainId: relayChainIdSchema,
})
